import openModal from './openModal';
import resetForm from './resetForm';
import setIsNewRecord from './setIsNewRecord';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(setIsNewRecord(true));
    dispatch(openModal(true));
};
